const crowUrl = '/brand/CuervoBlanco_Cuervo_Cropped.svg'

export function Footer() {
  return (
    <footer className="site-footer" id="contacto">
      <div className="site-footer__brand">
        <span className="site-footer__crow"><img src={crowUrl} alt="" /></span>
        <div>
          <strong>CUERVO BLANCO</strong>
          <span>SEMILLAS Y ALIMENTOS</span>
        </div>
      </div>
      <p>CALIDAD QUE NUTRE NEGOCIOS Y PERSONAS.</p>
      <div className="site-footer__contact">
        <a className="site-footer__phone" href="tel:+527718348710">+52 771 834 8710</a>
        <a
          className="site-footer__channel"
          href="https://wa.me/527718348710"
          target="_blank"
          rel="noreferrer"
          aria-label="Abrir WhatsApp de Cuervo Blanco"
        >
          Llamadas y WhatsApp
        </a>
      </div>
      <span>© {new Date().getFullYear()} Cuervo Blanco.</span>
    </footer>
  )
}
